export default "__VITE_ASSET__DZfdhFXB__"